import React from "react";
import { Row, Col } from "antd";
import { STATUSES } from "../../../data/statuses";
import LeadColumn from "./LeadColumn";

export default function DesktopBoard({ leads }) {
  return (
    <Row gutter={8}>
      {STATUSES.map((s) => (
        <Col span={4} key={s.key}>
          <LeadColumn
            title={s.title}
            leads={leads.filter((l) => l.status === s.key)}
          />
        </Col>
      ))}
    </Row>
  );
}
